import qs from 'qs'
import 'clientjs'

const state = {
    routes: [],
    doers: [],
    emails: [],
    orderOptions: {
        selectedType: 1,
        doer: '',
        email: ''
    }
}

const getters = {
    orderRouteParams: (state, getters, rootState) => {
        return JSON.stringify( {
            Name_app: 'Covid',
            Name_module: 'Covid',
            Name_event: 'order_route',
            link_order: rootState.linkOrder
        })
    },
    orderActionParams: (state, getters, rootState) => {
        return JSON.stringify({
            Name_app: 'Covid',
            Name_module: 'Covid',
            Name_event: 'order_action',
            link_order: rootState.linkOrder,
            id_action: state.orderOptions.selectedType,
            doer: state.orderOptions.doer,
            doer_mail: state.orderOptions.email
        })
    },
    query: () => {
        const client = new ClientJS();
        const fingerprint = client.getFingerprint();

        return JSON.stringify({
            // Name_app: 'Covid',
            browser_hash: fingerprint
        })
    },

}


const mutations = {
    
    ORDER_ROUTE(state, payload) {
        state.routes = payload.body;
    },
    SELECT_TYPE(state, payload) {
        state.orderOptions.selectedType = payload;
    },
    UPDATE_DOER(state, payload) {
        state.orderOptions.doer = payload;
    },
    UPDATE_EMAIL(state, payload) {
        state.orderOptions.email = payload;
    },
    
}

const actions = {
    selectType({ commit }, context) {
        commit("SELECT_TYPE", context)
    },
    updateDoer({ commit }, context) {
        commit('UPDATE_DOER', context);
    },
    updateEmail({ commit }, context) {
        commit('UPDATE_EMAIL', context);
    },

    getOrderRoute: async({commit, state, getters}) => {
        try {
            let orderRouteResponse = await fetch(`https://host2.medsafe.tech/api/check_file`, {
                method: "POST", 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.orderRouteParams
                })
            });
            if (orderRouteResponse.status >= 200 && orderRouteResponse.status < 300) {
                commit('ORDER_ROUTE', await orderRouteResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },

    sendOrderAction: async({commit, state, getters, dispatch}) => {
        try {
            let orderActionResponse = await fetch(`https://host2.medsafe.tech/api/check_file`, {
                method: "POST", 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.orderActionParams
                })
            });
            if (orderActionResponse.status >= 200 && orderActionResponse.status < 300) {
                commit('ORDER_ROUTE', await orderActionResponse.json());
                commit('SELECT_TYPE', 1);
                commit('UPDATE_DOER', null);
                commit('UPDATE_EMAIL', null);
            }
        } catch(err) { err => console.error(err) }
    },

    query: async({commit, getters}) => {

        try {
            let queryRes = await fetch(`https://host2.medsafe.tech/api/log_browser`, {
                method: "POST", 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.query
                })
            });
            if (queryRes.status >= 200 && queryRes.status < 300) {
                console.log(await queryRes.json());
            }
        } catch(err) { err => console.error(err) }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/order.js